import React, { useState, useEffect } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import TextInputTwoRow from "components/GenericComponent/TextInputTwoRow";
import NumberInput from "components/GenericComponent/NumberInput";
import NumberField from "components/GenericComponent/NumberField";
import { formatNumber } from "utils/currencyFormat";
import { formatMoney } from "utils/currencyFormat";
const laiTraGopText = {
  1: "Lãi kỳ",
  2: "Tổng thu 1 kỳ",
  0: "Lãi tổng",
};

const LaiPhang = (props) => {
  let {
    data,
    register,
    chonngaygiaodich,
    IsEditChoVay,
    func,
    control,
    errors,
    config,
    ChoPhepSuaMaHopDong,
    IsCopy,
    isCauHinhKhachHangBinhAn,
  } = props;
  let {
    onChangeNgayVay,
    onChangeAttNumberChoVay,
    onChangeValueSoTienLai,
    onChangeTypePaid,
    onChangeAttTextChoVay,
    onChangeStatusPaidHo,
    onChangeNgayThanhToan,
  } = func;
  const [intNhapLaiSuat, setNhapLaiSuat] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  let {
    NgayVay,
    ChoVayId,
    Sotienvay,
    StatusPaidHo,
    BocTrongVong,
    CountTypePaid,
    BeforeAfter,
    Note,
    ValueLai,
    Phantram,
    TypePaid,
    TienThuHangKy,
    LaiTraGop,
    TienCatTruoc,
    NgayThanhToan,
    ValueHoaHong,
  } = data;
  let {
    _anDinhNgayThangTraGop,
    _allBeforeAfterTraGop,
    _allTraThieuTraDuTraGop,
    _allKyGopTraGop,
    HoaHongTraGop,
  } = config ? config : {};

  const onChangeNhapLaiSuat = (val) => (evt) => {
    setNhapLaiSuat(val);
    if (val === 2) {
      onChangeValueSoTienLai("Phantram", 0);
      onChangeValueSoTienLai("ValueLai", 0);
    } else {
      onChangeValueSoTienLai("ValueLai", 0);
    }
  };

  useEffect(() => {
    if (
      intNhapLaiSuat === 2 &&
      Sotienvay > 0 &&
      Phantram != null &&
      Phantram > 0
    ) {
      onChangeValueSoTienLai("ValueLai", (Phantram * Sotienvay) / 100);
    }
  }, [ValueLai, Phantram, Sotienvay, intNhapLaiSuat]);

  useEffect(() => {
    if (Phantram != undefined && Phantram != null && Phantram > 0) {
      setNhapLaiSuat(2);
    } else {
      setNhapLaiSuat(1);
    }
  }, []); // chỉ chạy 1 lần khi load trang
  return (
    <>
      <div className="col-md-4">
        <label className="label-control color7-bold">
          Ngày vay <span className="canh-bao-red">*</span>
        </label>
        <br />
        <DateTimePicker
          onChange={onChangeNgayVay}
          value={NgayVay}
          name="NgayVay"
          customInputRef={register}
          customInput={<input name="NgayVay" ref={register}></input>}
          readOnly={IsEditChoVay || !chonngaygiaodich}
        ></DateTimePicker>
      </div>
      {_anDinhNgayThangTraGop && (
        <div
          id="ctl00_ContentPlaceHolder_AddChoVayHo_boxNgayThanhToan"
          class="col-md-4"
        >
          <label className="label-control color7-bold">Ngày thanh toán</label>
          <br />
          <DateTimePicker
            onChange={onChangeNgayThanhToan}
            value={NgayThanhToan}
            customInputRef={register}
            readOnly={!chonngaygiaodich || IsEditChoVay}
            name="NgayThanhToan"
            customInput={<input name="NgayThanhToan" ref={register}></input>}
          ></DateTimePicker>
        </div>
      )}
      {isCauHinhKhachHangBinhAn && (
        <div
          id="ctl00_ContentPlaceHolder_AddChoVayHo_boxNgayThanhToan"
          class="col-md-4"
        >
          <label class="col-md-2 label-control color7-bold">
            Ngày bắt đầu tính lãi
          </label>
          <br />

          <DateTimePicker
            onChange={onChangeNgayThanhToan}
            value={NgayThanhToan}
            customInputRef={register}
            readOnly={!chonngaygiaodich || IsEditChoVay}
            name="NgayThanhToan"
            customInput={<input name="NgayThanhToan" ref={register}></input>}
          ></DateTimePicker>
        </div>
      )}
      {!IsCopy && (
        <div className="col-md-4">
          <TextInputTwoRow
            labelClass="col-md-2 label-control"
            inputClass="form-control input-sm"
            inputWrapClass="col-md-4"
            wrapperClass="form-group row"
            labelText="Mã hợp đồng"
            placeholder="Mã hợp đồng"
            inputProps={{
              ref: register,
              name: "Code",
              readOnly: IsEditChoVay,
            }}
          ></TextInputTwoRow>
        </div>
      )}
      <div className="col-md-12"></div>
      <div className="col-md-4">
        <NumberInput
          labelClass="col-md-4 label-control"
          inputClass="form-control input-sm"
          inputWrapClass="col-md-8"
          wrapperClass="form-group row"
          labelText="Tổng tiền vay"
          starRed="*"
          placeholder="10,000,000"
          inputProps={{
            name: "Sotienvay",
            value: Sotienvay,
            onChange: onChangeAttNumberChoVay("Sotienvay"),
            rules: {
              required: "Hãy nhập số tiền vay",
            },
            control: control,
            readOnly: IsEditChoVay,
          }}
          error={errors.Sotienvay}
        ></NumberInput>
      </div>
      <div className="col-md-4">
        <label class="color7-bold">Kiểu thu lãi</label>
        <select
          ref={register}
          className="form-control input-sm"
          onChange={onChangeStatusPaidHo()}
          value={StatusPaidHo}
          defaultValue={StatusPaidHo}
          disabled={IsEditChoVay || !_allTraThieuTraDuTraGop}
          name="StatusPaidHo"
        >
          <option value="1">Cắt lãi trước</option>
          <option value="2">Thu lãi sau</option>
        </select>
      </div>
      <div className="col-md-12"></div>
      <div className="col-md-4">
        <NumberInput
          labelClass="col-md-4 label-control"
          inputClass="form-control input-sm"
          inputWrapClass="col-md-8"
          wrapperClass="form-group row"
          labelText={
            StatusPaidHo === 1 ? "Tiền đưa khách" : laiTraGopText[LaiTraGop]
          }
          starRed="*"
          placeholder="10,000,000"
          inputProps={{
            name: intNhapLaiSuat === 2 ? "Phantram" : "ValueLai",
            value: intNhapLaiSuat === 2 ? Phantram : ValueLai,
            onChange: onChangeAttNumberChoVay(
              intNhapLaiSuat == 2 ? "Phantram" : "ValueLai"
            ),
            rules: {
              required: "Hãy nhập số tiền",
            },
            control: control,
            readOnly: IsEditChoVay,
          }}
          error={errors.ValueLai}
        ></NumberInput>
      </div>
      {StatusPaidHo === 2 && LaiTraGop !== 2 && (
        <div className="col-md-4 radio-button-nhap-tien">
          <label className="custom-radio">
            <input
              type="radio"
              name="NhapLaiSuat"
              onChange={onChangeNhapLaiSuat(1)}
              checked={intNhapLaiSuat === 1 ? true : false}
              disabled={IsEditChoVay}
            />{" "}
            <span className="radio-mark"></span>
            Nhập tiền
          </label>
          <label className="custom-radio radio-button-nhap-phan-tram">
            <input
              type="radio"
              name="NhapLaiSuat"
              onChange={onChangeNhapLaiSuat(2)}
              checked={intNhapLaiSuat === 2 ? true : false}
              disabled={IsEditChoVay}
            />{" "}
            <span className="radio-mark"></span>
            Nhập %
          </label>
        </div>
      )}

      {StatusPaidHo === 2 && intNhapLaiSuat === 2 && (
        <div className="col-md-4">
          <span className="row">
            <div className="col-md-1 btn-checkbox-them-moi">
              <img src="/app-assets/images/icon-turn-right-v2.png" />
            </div>
            <div className="col-md-10">
              <NumberInput
                labelClass="col-md-4 label-control"
                inputClass="form-control input-sm"
                inputWrapClass="col-md-8"
                wrapperClass="form-group row"
                labelText="Tiền lãi"
                placeholder="10,000,000"
                inputProps={{
                  name: "ValueLai",
                  value: ValueLai,
                  onChange: onChangeAttNumberChoVay("ValueLai"),
                  rules: {
                    required: "Hãy nhập số tiền",
                  },
                  control: control,
                  readOnly: true,
                }}
                error={errors.Phantram}
              ></NumberInput>
            </div>
          </span>
        </div>
      )}
      {StatusPaidHo === 1 && (
        <div className="col-md-4" style={{ paddingTop: "40px" }}>
          <span className="label-control color7-bold">
            ( Cắt lãi trước:{" "}
            <span className="color-xanh">{formatNumber(TienCatTruoc)}</span> )
          </span>
        </div>
      )}

      <div className="col-md-12"></div>
      <div className="col-md-4">
        <label className="label-control color7-bold">
          Bốc trong vòng <span className="canh-bao-red">*</span>
          <PopoversBootrap
            contentText="Là tổng thời gian cho góp ví dụ cho góp 50 ngày thì nhập là 50"
            titleText=""
            trigger={["hover", "focus"]}
            placement={"top"}
          >
            <i className="la la-question-circle tool-comment"></i>
          </PopoversBootrap>
        </label>
        <fieldset>
          <div className="input-group input-icon">
            <NumberField
              className="form-control input-sm"
              name={"BocTrongVong"}
              value={BocTrongVong}
              onChange={onChangeAttNumberChoVay("BocTrongVong")}
              inputRef={register}
              readOnly={IsEditChoVay}
            ></NumberField>
            <div className="input-group-append">
              <span className="input-group-text" id="basic-addon2">
                {TypePaid === 1 ? "Ngày" : "Tháng"}
              </span>
            </div>
          </div>
        </fieldset>
      </div>
      {_allKyGopTraGop ? (
        <div className="col-md-4 btn-checkbox-them-moi">
          <label className="label-control color7-bold">
            <input
              type="checkbox"
              name="TypePaid"
              value={TypePaid}
              checked={TypePaid !== 1}
              onChange={onChangeTypePaid()}
            />{" "}
            <span className="check-box color7-bold ">Tính theo tháng </span>
          </label>
        </div>
      ) : (
        <input
          type="hidden"
          value={StatusPaidHo}
          name="StatusPaidHo"
          ref={register}
        ></input>
      )}
      <div className="col-md-12"></div>
      <div className="col-md-4">
        <label className="label-control color7-bold">
          Kỳ góp <span className="canh-bao-red">*</span>
          <PopoversBootrap
            contentText="Ví dụ 10 ngày đóng tiền 1 lần thì nhập là 10"
            titleText=""
            trigger={["hover", "focus"]}
            placement={"top"}
          >
            <i className="la la-question-circle tool-comment"></i>
          </PopoversBootrap>
        </label>
        <fieldset>
          <div className="input-group input-icon">
            <NumberField
              className="form-control input-sm"
              name={"CountTypePaid"}
              value={CountTypePaid}
              inputRef={register}
              onChange={onChangeAttNumberChoVay("CountTypePaid")}
            ></NumberField>
            <div className="input-group-append">
              <span className="input-group-text" id="basic-addon2">
                {TypePaid === 1 ? "Ngày" : "Tháng"}
              </span>
            </div>
          </div>
        </fieldset>
      </div>
      <div className="col-md-4">
        <span className="row">
          <div className="col-md-1 btn-checkbox-them-moi">
            <img src="/app-assets/images/icon-turn-right-v2.png" />
          </div>
          <div className="col-md-10">
            <label className="label-control color7-bold">
              Tiền thu hàng kỳ
            </label>
            <input
              type="text"
              className="form-control input-sm text-center-new"
              value={formatMoney(TienThuHangKy)}
              readOnly
            />
          </div>
        </span>
      </div>
      <div className="col-md-12"></div>
      {_allBeforeAfterTraGop ? (
        <div className="col-md-4">
          <label className="label-control color7-bold">
            Kiểu thanh toán <span className="canh-bao-red">*</span>
          </label>

          <select
            name="BeforeAfter"
            className="form-control input-sm"
            ref={register}
            value={BeforeAfter}
            onChange={onChangeAttTextChoVay("BeforeAfter")}
            readOnly={IsEditChoVay}
          >
            <option value="1">Sau</option>
            <option value="2">Trước</option>
          </select>
        </div>
      ) : (
        <input
          type="hidden"
          name="BeforeAfter"
          className="form-control input-sm"
          ref={register}
          value={BeforeAfter}
        ></input>
      )}
      {HoaHongTraGop === 1 && (
        <NumberInput
          labelClass="col-md-2 label-control"
          inputClass="form-control input-sm"
          inputWrapClass="col-md-4"
          wrapperClass="form-group row"
          labelText={"Tiền hoa hồng"}
          inputProps={{
            name: "ValueHoaHong",
            value: ValueHoaHong,
            onChange: onChangeAttNumberChoVay("ValueHoaHong"),
            control: control,
            readOnly: IsEditChoVay,
          }}
        ></NumberInput>
      )}
      {/* <div className="form-group row">
          <label className="col-md-2 label-control" for="userinput1">
            Ghi chú
          </label>
          <div className="col-md-10">
            <textarea
              rows="2"
              className="form-control input-sm"
              name="Note"av
              placeholder=""
              value={Note}
              onChange={onChangeAttTextChoVay('Note')}
              ref={register}
              readOnly={IsEditChoVay}
            ></textarea>
          </div>
        </div> */}
    </>
  );
};
export default LaiPhang;
